import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { ExceptionDetailRow, ExceptionSummary } from "../../types";

interface ExceptionSummarySectionProps {
  summary?: ExceptionSummary;
  details?: ExceptionDetailRow[];
}

export const ExceptionSummarySection: React.FC<ExceptionSummarySectionProps> = ({ summary, details = [] }) => {
  if (!summary && (!details || details.length === 0)) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Exception Summary</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {summary && (
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
            <div className="p-3 border rounded-md">
              <p className="text-sm text-muted-foreground">Rules run</p>
              <p className="text-xl font-semibold">{summary.rulesRun}</p>
            </div>
            <div className="p-3 border rounded-md">
              <p className="text-sm text-muted-foreground">Passes</p>
              <p className="text-xl font-semibold text-green-600">{summary.passes}</p>
            </div>
            <div className="p-3 border rounded-md">
              <p className="text-sm text-muted-foreground">Fails</p>
              <p className="text-xl font-semibold text-red-600">{summary.failures}</p>
            </div>
            <div className="p-3 border rounded-md">
              <p className="text-sm text-muted-foreground">Open</p>
              <p className="text-xl font-semibold text-red-600">{summary.failuresOpen}</p>
            </div>
            <div className="p-3 border rounded-md">
              <p className="text-sm text-muted-foreground">Resolved</p>
              <p className="text-xl font-semibold text-green-600">{summary.failuresResolved}</p>
            </div>
          </div>
        )}

        {details && details.length > 0 && (
          <div className="border rounded-md">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Rule</TableHead>
                  <TableHead>Description</TableHead>
                  <TableHead>Result</TableHead>
                  <TableHead>Expected</TableHead>
                  <TableHead>Tolerance</TableHead>
                  <TableHead>Assigned/Checked by</TableHead>
                  <TableHead>Notes</TableHead>
                  <TableHead>Status</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {details.map((d, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{d.rule}</TableCell>
                    <TableCell className="max-w-[420px]"><div className="truncate">{d.description}</div></TableCell>
                    <TableCell>{d.result as any}</TableCell>
                    <TableCell>{d.expected as any}</TableCell>
                    <TableCell>{d.tolerance as any}</TableCell>
                    <TableCell>
                      <div className="flex flex-col">
                        {d.assignedTo && <span className="text-sm">{d.assignedTo}</span>}
                        {d.checkedBy && <span className="text-xs text-muted-foreground">Checked by {d.checkedBy}</span>}
                      </div>
                    </TableCell>
                    <TableCell className="max-w-[260px]"><div className="truncate">{d.notes}</div></TableCell>
                    <TableCell>
                      <Badge variant="outline">{d.status || ""}</Badge>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </CardContent>
    </Card>
  );
};


